var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._v(" 页面找不着了！返回 "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.pageFn}},[_vm._v("【登录】")]),_vm._v(" 页~ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }